/**
 * @generated SignedSource<<80e43e486a49e71b0b7cbeece2e9e526>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type liveUpdateSwitchLiveArticle$data = {
  readonly pushNotifications: boolean | null | undefined;
  readonly status: boolean | null | undefined;
  readonly " $fragmentType": "liveUpdateSwitchLiveArticle";
};
export type liveUpdateSwitchLiveArticle$key = {
  readonly " $data"?: liveUpdateSwitchLiveArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"liveUpdateSwitchLiveArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "liveUpdateSwitchLiveArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pushNotifications",
      "storageKey": null
    }
  ],
  "type": "LiveArticle",
  "abstractKey": null
};

(node as any).hash = "2980769068a83e5e5fb3c0ee1501eb8b";

export default node;
